import api from "@/api";
import Vue from "vue";

export default {
	actions: {
		async GetCooperationList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetCooperationList,
			});
			return response.data;
		},
		async GetCooperation(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetCooperation + entryId,
				data: entryId,
			});
			return response.data;
		},
		async CreateCooperation(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateCooperation,
				data: entry,
			});

			return response.data;
		},
		async UpdateCooperation(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateCooperation,
				data: entry,
			});
			return response.data;
		},
		async DeleteCooperation(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteCooperation,
				data: entry,
			});
			return response.data;
		},
	},
};
